import * as Immutable from 'immutable';
import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { localeData } from '../../../../locales/data';
import { StateType } from '../../../../reducers';
import { getDisabledSettings, tooltipInfo } from '../../../../reducers/EditorReducer/EditorHelper';
import { activeTabIndexSelector } from '../../../../reducers/EditorReducer/EditorSelector';
import { addModifiers } from '../../../../shared/helpers';
import { ToolTip } from '../../../ToolTip';
import { FormattedMessageHelper } from '../../../../shared/helpers/internationalization';

interface HOCSettingsTooltipProps {
  currentValue: any;
  activeTabIndex: any;
  hasChildTabs: any;
  isSuperAlpha?: boolean;
  settings: any;
  currentMultiTab: any;
  currentChildActiveTab: any;
  modifiers: any;
  name: any;
  language: string;
  onChangeHandlerPortal: (name: string, value: any) => void;
}

interface SettingsChoicesConnectedStateProps {
  options: any;
  activeTab: number;
}

interface FilterOptionsProps {
  options: any;
  language: string;
  name: string;
  isMultiOrSuper: boolean;
}

export const filterOptions = ({ options, language, name, isMultiOrSuper }: FilterOptionsProps) => {
  if (isMultiOrSuper && name === 'language') {
    return options.filter((option: any) => option.get('value') !== 'PYTHON');
  }
  return options;
};

const HOCSettingsTooltip =
  (Component: any) =>
  ({ language, currentValue, modifiers, options, ...props }: HOCSettingsTooltipProps & SettingsChoicesConnectedStateProps) => {
    const disabledOptions = getDisabledSettings(language);
    const disabled = Immutable.fromJS(disabledOptions).includes(props.name);
    let modifiersConcat = modifiers.concat(disabled ? ['disabled'] : []);
    modifiersConcat = modifiersConcat.concat(currentValue.hasError ? ['error'] : []);
    const isMultiOrSuper = !!props.hasChildTabs || !!props.isSuperAlpha;
    const newOptions = filterOptions({ options, language, name: props.name, isMultiOrSuper });

    return (
      <div className={addModifiers('code-editor-settings__form-element', modifiersConcat)}>
        <div className="code-editor-settings__form-element-label">
          <div className="code-editor-settings__form-element-label-name">
            <FormattedMessageHelper
              tagName="span"
              // @ts-ignore
              id={tooltipInfo.getIn([props.name, 'label'])}
              // @ts-ignore
              defaultMessage={localeData.en[tooltipInfo.getIn([props.name, 'label'])]}
            />
          </div>
          {/* @ts-ignore */}
          <ToolTip
            label={tooltipInfo.getIn([props.name, 'label'])}
            tooltipInfo={tooltipInfo.getIn([props.name, 'tooltipInfo'])}
            url={tooltipInfo.getIn([props.name, 'url'])}
            modifiers={currentValue.hasError ? ['error'] : []}
            hasError={currentValue.hasError}
          />
        </div>
        <Component
          currentValue={currentValue.value}
          min={currentValue.min}
          max={currentValue.max}
          step={currentValue.step}
          hasError={currentValue.hasError}
          options={newOptions}
          {...props}
        />
      </div>
    );
  };

const mapStateToProps = (state: StateType, ownProps: any): SettingsChoicesConnectedStateProps => ({
  options: state.getIn(['editor', 'options', ownProps.name, 'choices'].concat(ownProps.pathOptions)),
  // @ts-ignore
  activeTab: activeTabIndexSelector(state),
});

export default compose(connect<SettingsChoicesConnectedStateProps, any, any, StateType>(mapStateToProps, undefined), HOCSettingsTooltip);
